<template>
  <span>{{ this.nameText }}</span>
</template>

<script>
export default {
  name: 'DictText',
  props: {
    dictKey: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
  },
  created () {
    if (this.value) {
      this.selectedValue = this.value.split(',')
    }
    this.onFetch()
  },
  data () {
    return {
      nameText: "",
      options: [],
      selectedValue: []
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.selectedValue = []
        return
      }
      this.selectedValue = val.split(',')
      this.filterData(this.selectedValue)
    }
  },
  methods: {
    onFetch () {
      const that = this
      that.$http.get('/api/1/dict/cache/items.json?key=' + this.dictKey).then(function (response) {
        that.options = [...response.result]
        that.filterData(that.selectedValue)
      })
    },
    filterData (inputValue) {
      this.nameText = this.options.filter(item => inputValue.includes(item.value))
        .map(item => item.name)
        .join('、')
    }
  }
}
</script>

<style scoped>
</style>
